import Vue from "vue";

const modalsUser = Vue.observable({ email: '' });

export { modalsUser };